module.exports = __webpack_public_path__ + "static/media/favorite-bold.e7dacd83.svg";